export default __webpack_public_path__ + "static/media/blur_footer.6750b055.png";